export class GeneralModalData {
  constructor(
    public readonly title: string,
    public readonly message: string,
    public readonly primaryActionText: string,
    public readonly secondaryActionText?: string,
    public readonly shouldImmediatelyClose = true
  ) {}
}
